type JwtPayload = {
  exp?: number;
  [key: string]: unknown;
};

export const decodeJwt = (token: string): JwtPayload | null => {
  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const binary = atob(padded);
    const json = decodeURIComponent(
      Array.from(binary, (char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`).join(''),
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const isAccessTokenValid = (token: string): boolean => {
  if (!token) {
    return false;
  }

  const payload = decodeJwt(token);
  if (!payload) {
    return false;
  }

  if (typeof payload.exp === 'number') {
    return payload.exp * 1000 > Date.now();
  }

  return true;
};
